import SideBarLisence from "./Sidebar/SideBarLisence";
import classNames from "classnames/bind";
import styles from "./ViewVideo.module.css";
import LiveVideo from "./LiveVideo";
import { LisencePlateContext } from "../../../contexts";
import { useState } from "react";
const cx = classNames.bind(styles);
const ViewVideo = () => {
  const [cameraCode, setCameraCode] = useState([]);
  const [isApply, setIsApply] = useState(false);
  const [screen, setScreen] = useState({ total: 1 });
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [info, setInfo] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [plate, setPlate] = useState("On");
  const valueProvider = {
    cameraCode,
    setCameraCode,
    isApply,
    setIsApply,
    screen,
    setScreen,
    isFullScreen,
    setIsFullScreen,
    currentPage,
    setCurrentPage,
    showInfo,
    setShowInfo,
    info,
    setInfo,
    plate,
    setPlate,
  };
  return (
    <LisencePlateContext.Provider value={valueProvider}>
      <div className={cx("container")}>
        <div className={cx("sidebar")}>
          <SideBarLisence />
        </div>
        <div className={cx("content")}>
          <LiveVideo />
        </div>
      </div>
    </LisencePlateContext.Provider>
  );
};

export default ViewVideo;
